import { useMemoryStatus } from "./memory-monitor";

export const MemoryWarningBanner = () => {
  const memoryStatus = useMemoryStatus();

  if (memoryStatus.level === "none") {
    return null;
  }

  const bgColor =
    memoryStatus.level === "critical"
      ? "bg-red-50 text-red-600"
      : "bg-yellow-50 text-yellow-600";

  const icon =
    memoryStatus.level === "critical"
      ? "fa-circle-exclamation"
      : "fa-triangle-exclamation";

  return (
    <div
      className={`${bgColor} text-sm px-4 py-3 rounded-lg flex items-center mb-4`}
    >
      <i className={`fa-regular ${icon} mr-2 text-lg`}></i>
      <span>{memoryStatus.message}</span>
    </div>
  );
};
